import type { ReactNode } from "react";
import "./StatusPill.css";

export type PillTone = "lit" | "shut" | "paused";

interface StatusPillProps {
  tone: PillTone;
  className?: string;
  children: ReactNode;
}

export default function StatusPill({ tone, className, children }: StatusPillProps) {
  const classes = ["pill", `pill--${tone}`, className].filter(Boolean).join(" ");
  return (
    <p className={classes} role="status">
      <span className="pill__dot" aria-hidden="true" />
      <span>{children}</span>
    </p>
  );
}
